import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  RoutingAnswer,
  RoutingRequest,
  RoutingWithOpeningTimesRequest,
} from '../../lead.model';
import { environment } from '../../../environments/environment';
import { BaseHttpService } from '../base-http.service';

@Injectable({
  providedIn: 'root',
})
export class LeadRoutingService extends BaseHttpService {
  constructor(private readonly http: HttpClient) {
    super();
  }

  calculateRoute(routingRequest: RoutingRequest): Observable<RoutingAnswer> {
    return this.applyHttpOperators(
      this.http.post<RoutingAnswer>(
        environment.backend_host + '/routing',
        routingRequest,
      ),
    );
  }

  calculateRouteWithOpeningTimes(
    routingRequest: RoutingWithOpeningTimesRequest,
  ): Observable<RoutingAnswer> {
    return this.applyHttpOperators(
      this.http.post<RoutingAnswer>(
        environment.backend_host + '/routingWithOpeningTimes',
        routingRequest,
      ),
    );
  }
}
